// extracted by mini-css-extract-plugin
module.exports = {"container":"network_container__3A0EH","topWrapper":"network_topWrapper__39YbQ","midWrapper":"network_midWrapper__3lQHb","bottomWrapper":"network_bottomWrapper__HXDWt"};